import { render, staticRenderFns } from "./MortgageDebt.vue?vue&type=template&id=0dba4a46&scoped=true&"
import script from "./MortgageDebt.vue?vue&type=script&lang=js&"
export * from "./MortgageDebt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dba4a46",
  null
  
)

export default component.exports